export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_TRICKS_MODAL = 'SHOW_TRICKS_MODAL';
export const SHOW_AVAILABLE_UPDATE_MODAL = 'SHOW_AVAILABLE_UPDATE_MODAL';
export const LOGOUT = 'LOGOUT';
